import PartnerPreferences from "./PartnerPreferences";

export default PartnerPreferences;
